import { render, staticRenderFns } from "./TwoStepVerification.vue?vue&type=template&id=66828d9e&scoped=true"
import script from "./TwoStepVerification.vue?vue&type=script&lang=js"
export * from "./TwoStepVerification.vue?vue&type=script&lang=js"
import style0 from "./TwoStepVerification.vue?vue&type=style&index=0&id=66828d9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_ded4d8edc98a099a331a0dfa5a479e42/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66828d9e",
  null
  
)

export default component.exports